import { DashboardTemplate } from "../templates";

export const DashboardPage = () => {
  return (
    <DashboardTemplate />
  );
}                                                     
